import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlgorithmModule } from '../algorithm/algorithm.module';
import { SharedModule } from '../shared/shared.module';
import { ActionConfiguratorComponent } from './action-configurator/action-configurator.component';
import { CustomRandomizationComponent } from './custom-randomization/custom-randomization.component';
import { ImageFeatureExtractorComponent } from './image-feature-extractor/image-feature-extractor.component';
import { NeuralNetworkComponent } from './neural-network/neural-network.component';
import { ObservationElementDetailsComponent } from './observation-element-details/observation-element-details.component';
import { RandomizationSidebarComponent } from './randomization-sidebar/randomization-sidebar.component';
import { ArchitectureVisualizationComponent } from './skill-architecture/architecture-visualization/architecture-visualization.component';
import { LayerContextMenuComponent } from './skill-architecture/layer-context-menu/layer-context-menu.component';
import { SkillArchitectureSelectionRowComponent } from './skill-architecture/skill-architecture-selection-row/skill-architecture-selection-row.component';
import { SkillArchitectureComponent } from './skill-architecture/skill-architecture.component';

@NgModule({
    declarations: [
        SkillArchitectureComponent,
        LayerContextMenuComponent,
        ArchitectureVisualizationComponent,
        SkillArchitectureSelectionRowComponent,
        NeuralNetworkComponent,
        ObservationElementDetailsComponent,
        CustomRandomizationComponent,
        RandomizationSidebarComponent,
        ActionConfiguratorComponent,
        ImageFeatureExtractorComponent,
    ],
    imports: [
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        DragDropModule,
        CommonModule,
        AlgorithmModule,
    ],
    exports: [SkillArchitectureComponent, NeuralNetworkComponent],
})
export class SkillArchitectureEditorModule {}
